
<Teleport :to="teleport">
  <!-- 遮罩层 -->
  <Overlay
    v-if="overlay"
    :visible="visible"
    :overlay-class="overlayClass"
    :z-index="normalizedZIndex"
    :duration="duration"
    :lock-scroll="lockScroll"
    @click="onClickOverlay"
  />
  <!-- 弹窗内容 -->
  <Transition
    :name="n(`--pop-${position}`)"
    :duration="animationDuration"
    @after-enter="onOpened"
    @after-leave="onClosed"
  >
    <div
      v-show="visible"
      :class="[classes(n(), n('$--box'), n(`--${position}`), [position === 'center' && isLiteapp, n('--center-liteapp')]), popAttrs.class]"
      :style="{
        ...popStyle,
        ...popAttrs.style,
      }"
      role="dialog"
      aria-modal="true"
      v-bind="$attrs"
    >
      <!--
        center 定位：
        - H5（Vue2/2.7/3）：外层 .popup 直接用 transform 居中（原生行为，遮罩点击/按钮点击均正常）；
        - LiteApp：transform 会导致点击 hit-testing 错位，改用外层 .popup--center-liteapp 全屏 flex 容器居中，
          并用内层 .popup__center-body 作为真正的内容盒子承载背景/滚动。
        其余定位（top/bottom）保持原结构不变。
      -->
      <template v-if="position === 'center' && isLiteapp">
        <div :class="n('center-body')">
          <slot v-if="showSlot" />
        </div>
      </template>
      <template v-else>
        <slot v-if="showSlot" />
      </template>
    </div>
  </Transition>
</Teleport>
